import { API_BASE_URL } from '@/config/api';
import { apiClient } from '@/lib/api/client';
import { User } from '@/components/settings/types';

export interface UserDetails {
  id: string;
  name: string | null;
  email: string | null;
  role: string | null;
  notification_settings: {
    email: boolean;
    slack: boolean;
    webhook: boolean;
    test_failures: boolean;
    test_successes: boolean;
    alert_triggers: boolean;
    system_updates: boolean;
  } | null;
  onboarding_completed: number;
}

export interface UserUpdateRequest {
  name?: string;
  email?: string;
  role?: string;
  notification_settings?: {
    email?: boolean;
    slack?: boolean;
    webhook?: boolean;
    test_failures?: boolean;
    test_successes?: boolean;
    alert_triggers?: boolean;
    system_updates?: boolean;
  };
  onboarding_completed?: number;
}

export async function getUserDetails(userId: string) {
  return apiClient.get<UserDetails>(`/api/users/${userId}`);
}

export async function updateUserDetails(userId: string, userData: UserUpdateRequest) {
  return apiClient.put<UserDetails>(`/api/users/${userId}`, userData);
} 